import React, { useState } from "react";
import { Typography, Button, Grid, TextField, Snackbar, Alert, Box, CircularProgress } from "@mui/material";
import Layout from "./UserLayout";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { formFieldStyles, labelStyles } from "../../styles/formStyles";
import { verifyOTP } from "../../services/User";
import { IVerifyOTPDTO } from "../../interfaces/User";
import { useAuth } from "../../auth/AuthProvider";

const OTPVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const email = location.state?.email;
  const status = location.state?.status;

  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [openError, setOpenError] = useState(false);
  const [loading, setLoading] = useState(false);

  const validate = (): boolean => {
    if (!otp) {
      setError("OTP is required");
      return false;
    }
    if (!/^[0-9]+$/.test(otp)) {
      setError("Only numbers allowed");
      return false;
    }
    if (otp.length !== 4) {
      setError("OTP must be 4 digits");
      return false;
    }
    setError("");
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      const dto = {} as IVerifyOTPDTO;
      dto.email = email;
      dto.otp = otp;
      const res = await verifyOTP(dto);
      console.log("verify otp response", res);
      if (res && res.status === "success") {
        const data = res.rawResponse?.data?.data;
        console.log("OTP verification data", data);
        if(data)  {
          login(data.accessToken as string);
        }
        
        navigate("/set-new-password", { state: { email } });
      }
      else if (res && res.status === "error"){
        setErrMsg(res.errorResponse?.response?.message ||  res.errorResponse?.response?.data?.message|| "Invalid OTP");
        setOpenError(true);
      }
      
    } catch {
      setErrMsg("Invalid or expired OTP");
      setOpenError(true);
    } finally {
      setLoading(false);
    }
  };
  const handleSnackbarClose = () => {
    setOpenError(false);
  };
  return (
    <Layout>
      <Typography mb={1.5}>
        Enter the OTP sent to the <b>{email}</b>
      </Typography>

      <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography component="label" sx={labelStyles}>
              OTP <span style={{ color: "#FE0909" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              error={!!error}
              helperText={error}
              sx={formFieldStyles}
            />
          </Grid>

          <Grid item xs={12}>
            {!loading && (
            <Button
            onClick={handleSubmit}
            fullWidth
            sx={{
              borderRadius: "6px",
              background: "#005EFF",
              color: "#fff",
              fontWeight: 600,
              py: 1,
              textTransform: "none",
              "&:hover": {
                background: "#0047cc",
              },
            }}
            endIcon={<ArrowForwardIcon />}
          >
            Verify OTP
          </Button>
            )}
            {loading && (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress />
              </Box>
            )}
          </Grid>

          <Grid item xs={12}>
            {!status || status !== "forgot" ? (
              <Button
                fullWidth
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate("/signup")}
                sx={{
                  textTransform: "none",
                }}
              >
                Back to Signup
              </Button>
            ) : (
              <Button
                fullWidth
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate("/login")}
                sx={{
                  textTransform: "none",
                }}
              >
                Back to Login
              </Button>
            )}
          </Grid>
        </Grid>

      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={openError} autoHideDuration={5000} onClose={handleSnackbarClose}>
        <Alert severity="error" variant="filled" sx={{ width: "100%" }}>{errMsg}</Alert>
      </Snackbar>
    </Layout>
  );
};

export default OTPVerification;
